import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { IDeltaHedgeAccountSearchParam } from "../../../Interfaces/deltaHedgeAccounts";
import { setHeltaHedgeAccountsAddEditModalFlag } from "../../../Features/DeltaHedgeAccounts/deltaHedgeAccountsSlice";
import AddEditForm from "./AddEditForm";
import Modal from "../../../Components/Modal/Modal";
import DeltaHedgeAccountTable from "../../../Tables/DeltaHedgeAccount/Accounts/DeltaHedgeAccountTable";
import { useState } from "react";
// Common Components
import { Button } from "src/Components";
// Local Components
import Strategy from "./Strategy";

const Accounts = () => {
  // state
  const [isStrategyModalOpen, setIsStrategyModalOpen] = useState(false);
  const [searchParams, setSearchParams] = useState(
    {} as IDeltaHedgeAccountSearchParam
  );

  const addEditModalFlag = useAppSelector(
    (store) => store.deltaHedgeAccountsSlice.addEditModalFlag
  );

  const dispatch = useAppDispatch();

  return (
    <>
      {isStrategyModalOpen ? (
        <Modal
          UI={<Strategy />}
          onClose={() => setIsStrategyModalOpen(false)}
          // modalBoxClassName="!min-w-[360px]"
        />
      ) : (
        <></>
      )}

      <div className="flex justify-end items-center gap-3 w-full">
        <div className="w-min">
          <Button
            text={"استراتژی"}
            variant="outlined"
            onClick={() => setIsStrategyModalOpen(true)}
          />
        </div>
        <div
          className="bg-sky-600 rounded-full flex justify-center items-center !w-11 !h-11 cursor-pointer"
          onClick={() => dispatch(setHeltaHedgeAccountsAddEditModalFlag(true))}
        >
          <AddIcon className="text-white" />
        </div>
      </div>
      {addEditModalFlag ? (
        <Modal
          UI={<AddEditForm />}
          onClose={() => dispatch(setHeltaHedgeAccountsAddEditModalFlag(false))}
          modalBoxClassName="!min-w-[360px]"
        />
      ) : (
        <></>
      )}

      <DeltaHedgeAccountTable searchParams={searchParams} />
    </>
  );
};

export default Accounts;
